<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="notification-dropdown-content">
    <section class="main-content">
      <div
        class="is-flex is-justify-content-space-between mb-10"
        :class="{ 'custom-nav': isCollapse }"
      >
        <h1 class="is-6 has-text-weight-semibold is-flex is-align-items-center">
          <div
            class="is-flex"
            :class="{ 'cursor-pointer': isCollapse }"
            :role="isCollapse ? 'button' : ''"
            @click="toggleCollapse()"
          >
            <b-icon v-if="isCollapse" icon="arrow-left"></b-icon>
            <span class="mr-5">{{ General.NOTIFICATIONS }}</span>
          </div>
          <routerLink
            role="link"
            :to="{
              path: '/app/configuracoes-usuario',
              query: { activeTab: 'notifications-config' }
            }"
            @click.native="parentComponentRef.toggle()"
          >
            <b-icon
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              icon="bell-cog"
            />
          </routerLink>
        </h1>
        <div
          v-if="readNotificationList.length"
          role="button"
          type="is-text is-white"
          class="cursor-pointer is-underlined"
          @click="confirmReadAll"
        >
          {{ General.TEXTS.MARK_ALL_READ_2 }}
        </div>
      </div>

      <b-tabs
        v-model="tabSelected"
        position="is-centered"
        expanded
        class="notification-tabs"
      >
        <b-tab-item value="all">
          <div slot="header" class="custom-header has-text-weight-semibold">
            <label
              class="tab-label"
              :class="tabSelected == `all` ? `tab-selected` : ``"
            >
              {{ General.ALL_FEM }}
            </label>
            <div
              class="count-container"
              :class="tabSelected == `all` ? `selected` : ``"
            >
              <span>
                {{ getRecentNotifications.count }}
              </span>
            </div>
          </div>
          <div class="notification-wrapper">
            <template v-if="readNotificationList.length">
              <div
                v-for="(notification, index) in readNotificationList"
                :key="index"
              >
                <div
                  class="notification-card has-text-color-7"
                  :class="{ 'notification-readed': notification.is_readed }"
                >
                  <div
                    class="columns is-mobile mb-0"
                    @click="toggleNotificationDropdown(notification)"
                  >
                    <div class="column is-size-6 has-text-weight-semibold">
                      {{ notification.title }}
                    </div>
                    <div
                      class="column is-size-7 has-text-weight-semibold has-text-right"
                    >
                      {{
                        new Date(notification.date) | dateFormat("DD/MM/YYYY")
                      }}
                    </div>
                  </div>

                  <div class="notification-message">
                    <span
                      class="flex-1 is-size-7"
                      style="min-width: auto;"
                      @click="toggleNotificationDropdown(notification)"
                    >
                      {{ notification.description }}
                      <span
                        v-if="notification.descriptionAfterLink"
                        :class="{ 'notification-link': notification.url_pdf }"
                        @click.stop="viewDocument(notification)"
                      >
                        {{ notification.auxiliary_message }}
                      </span>
                      <span v-if="notification.descriptionAfterLink">
                        {{ notification.descriptionAfterLink }}
                      </span>
                    </span>
                    <div>
                      <b-tooltip
                        v-if="!notification.is_disabled"
                        :type="isContrast ? 'is-white' : 'is-blue-oil'"
                        position="is-top"
                        :label="General.DISABLE_NOTIFICATION"
                      >
                        <b-button
                          type="is-text"
                          @click="disableNotification(notification)"
                        >
                          <b-icon
                            icon="bell-off"
                            :type="isContrast ? 'is-white' : 'is-blue-oil'"
                          />
                        </b-button>
                      </b-tooltip>
                      <b-tooltip
                        :type="isContrast ? 'is-white' : 'is-blue-oil'"
                        position="is-top"
                        :label="General.DELETE"
                      >
                        <b-button
                          type="is-text"
                          @click="deleteNotification(notification.id)"
                        >
                          <b-icon
                            icon="delete"
                            :type="isContrast ? 'is-white' : 'is-blue-oil'"
                          />
                        </b-button>
                      </b-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else
              ><p
                class="is-flex is-justify-content-center has-text-color-7 my-10"
              >
                {{ General.TEXTS.NONE_NOTIFICATION }}
              </p>
            </template>
          </div>
        </b-tab-item>
        <b-tab-item value="unreaded">
          <div slot="header" class="custom-header has-text-weight-semibold">
            <label
              class="tab-label"
              :class="tabSelected == `unreaded` ? `tab-selected` : ``"
            >
              {{ App.NotificationsConfigScreen.NON_READED }}
            </label>
            <div
              class="count-container"
              :class="tabSelected == `unreaded` ? `selected` : ``"
            >
              <span>
                {{ getUnreadedRecentNotifications.count }}
              </span>
            </div>
          </div>

          <div class="notification-wrapper">
            <template v-if="unreadNotificationList.length">
              <div
                v-for="(notification, index) in unreadNotificationList"
                :key="index"
              >
                <div
                  class="notification-card"
                  :class="{ 'notification-readed': notification.is_readed }"
                >
                  <div
                    class="columns is-mobile mb-0"
                    @click="toggleNotificationDropdown(notification)"
                  >
                    <div class="column is-size-6 has-text-weight-semibold">
                      {{ notification.title }}
                    </div>
                    <div
                      class="column is-size-7 has-text-weight-semibold has-text-right"
                    >
                      {{
                        new Date(notification.date) | dateFormat("DD/MM/YYYY")
                      }}
                    </div>
                  </div>

                  <div class="notification-message">
                    <span
                      class="flex-1 is-size-7"
                      style="min-width: auto;"
                      @click="toggleNotificationDropdown(notification)"
                    >
                      {{ notification.description }}
                      <span
                        v-if="notification.descriptionAfterLink"
                        :class="{ 'notification-link': notification.url_pdf }"
                        @click.stop="viewDocument(notification)"
                      >
                        {{ notification.auxiliary_message }}
                      </span>
                      <span v-if="notification.descriptionAfterLink">
                        {{ notification.descriptionAfterLink }}
                      </span>
                    </span>
                    <div>
                      <b-tooltip
                        v-if="!notification.is_disabled"
                        :type="isContrast ? 'is-white' : 'is-blue-oil'"
                        position="is-top"
                        :label="General.DISABLE_NOTIFICATION"
                      >
                        <b-button
                          type="is-text"
                          @click="disableNotification(notification)"
                        >
                          <b-icon
                            icon="bell-off"
                            :type="isContrast ? 'is-white' : 'is-blue-oil'"
                          />
                        </b-button>
                      </b-tooltip>
                      <b-tooltip
                        :type="isContrast ? 'is-white' : 'is-blue-oil'"
                        position="is-top"
                        :label="General.DELETE"
                      >
                        <b-button
                          type="is-text"
                          @click="deleteNotification(notification.id)"
                        >
                          <b-icon
                            icon="delete"
                            :type="isContrast ? 'is-white' : 'is-blue-oil'"
                          />
                        </b-button>
                      </b-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <p
                class="is-flex is-justify-content-center has-text-color-7 my-10"
              >
                {{ App.NotificationsConfigScreen.NONE_NOTIFICATION_NON_READED }}
              </p>
            </template>
          </div>
        </b-tab-item>
      </b-tabs>
    </section>

    <b-button
      class="notification-screen-button"
      :type="isContrast ? 'is-white' : 'is-blue-oil'"
      expanded
      tag="router-link"
      :to="{
        path: '/app/configuracoes-usuario',
        query: { activeTab: 'notifications' }
      }"
      @click.native="parentComponentRef.toggle()"
      >{{ App.NotificationsConfigScreen.VIEW_ALL_NOTIFICATIONS }}</b-button
    >
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalWarning from "@/views/App/ModalWarning.vue";

import { General, App } from "@/utils/constants";

export default {
  name: "NotificationBellContent",
  props: {
    parentComponentRef: {
      type: Object,
      default: () => {}
    },
    isCollapse: {
      type: Boolean,
      default: false
    },
    toggleCollapse: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      General,
      App,
      tabSelected: "all"
    };
  },
  computed: {
    ...mapGetters({
      getRecentNotifications: "getRecentNotifications",
      getUnreadedRecentNotifications: "getUnreadedRecentNotifications",
      user: "getCurrentUser",
      isContrast: "isContrast"
    }),

    unreadNotificationList() {
      return (
        this.getUnreadedRecentNotifications.results?.map(notification => {
          const description = notification.description;
          const hasLink = description.includes("LINK");
          return {
            ...notification,
            description: hasLink
              ? description.split("LINK")[0]
              : notification.description,
            descriptionAfterLink: hasLink ? description.split("LINK")[1] : null
          };
        }) || []
      );
    },

    readNotificationList() {
      return (
        this.getRecentNotifications.results?.map(notification => {
          const description = notification.description;
          const hasLink = description.includes("LINK");
          return {
            ...notification,
            description: hasLink
              ? description.split("LINK")[0]
              : notification.description,
            descriptionAfterLink: hasLink ? description.split("LINK")[1] : null
          };
        }) || []
      );
    }
  },

  methods: {
    ...mapActions({
      userNotificationRequest: "userNotificationRequest",
      readNotification: "readNotification",
      deleteNotificationRequest: "deleteNotificationRequest",
      readAllNotifications: "readAllNotifications",
      everyTypeUserNotificationRequest: "everyTypeUserNotificationRequest",
      getCompleteProcessFile: "getCompleteProcessFileStream",
      saveUserNotificationConfig: "saveUserNotificationConfig"
    }),

    async requestNotificationLists() {
      await this.userNotificationRequest({
        currentPage: 1,
        perPage: 20,
        listType: "BELL_AREA_ALL"
      });
      await this.userNotificationRequest({
        currentPage: 1,
        perPage: 20,
        listType: "BELL_AREA_UNREAD"
      });
    },

    async deleteNotification(notificationId) {
      this.parentComponentRef.toggle();
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: `${this.General.TEXTS.CONFIRM_DELETE_NOTIFICATION}`,
          confirm: async () => {
            this.isLoading = true;
            await this.deleteNotificationRequest([notificationId]);
            await this.everyTypeUserNotificationRequest();
            this.isLoading = false;
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    confirmReadAll() {
      this.parentComponentRef.toggle();
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: `${this.General.TEXTS.CONFIRM_MARK_ALL_READ}?`,
          confirm: async () => {
            await this.readAllNotifications();
            await this.everyTypeUserNotificationRequest();
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    toggleNotificationDropdown(notification) {
      this.readNotification([notification.id]);
      this.parentComponentRef.toggle();
    },

    viewDocument(notification) {
      if (notification.url_pdf) window.open(notification.url_pdf, "_blank");
    },

    async disableNotification(notification) {
      const status = await this.saveUserNotificationConfig([
        {
          notification: notification.sys_notify_type_id,
          type: 3,
          user_id: this.user.id,
          enable: false
        }
      ]);

      if (status) {
        this.snackToast.open({
          message: General.TEXTS.DISABLE_NOTIFICATION.replace(
            "(NOTIFICATION)",
            notification.type
          ),
          type: "is-success",
          duration: 3000
        });
        await this.requestNotificationLists();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.notification-dropdown-content {
  width: 500px;
  max-width: 75vw;

  @media screen and (max-width: $tablet) {
    width: 100%;
    max-width: none;
  }

  .main-content {
    padding: 15px;
    padding-bottom: 0;

    .custom-nav {
      background-color: $background-color;
      margin: -15px;
      padding: 15px;
    }

    .tab-label {
      color: $color-7;
      padding: 2px 20px;
    }

    .tab-selected {
      border-radius: 11px;
      background-color: $color-23;
    }

    .notification-wrapper {
      max-height: 400px;
      overflow-y: auto;
      overflow-x: hidden;

      .notification-card {
        background-color: $background-color;
        border-radius: 5px;
        padding: 10px;
        margin: 10px 0;
        cursor: pointer;
        -ms-word-break: break-all;
        word-break: break-all;

        /* Non standard for WebKit */
        word-break: break-word;

        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        hyphens: auto; /* Optional */
        &:hover {
          color: $primary;
        }
      }

      .notification-readed {
        background-color: $background-light;
        border: 1px solid $background-color;
      }
    }
  }
}

.custom-header {
  display: flex;
  gap: 5px;
}

.count-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 11px;
  min-height: 22px;
  min-width: 22px;
  background-color: $color-7;
  color: $color-1;
  padding: 0 5px;
  &.selected {
    color: $color-7;
    background-color: $color-23;
  }
}

.notification-message {
  display: flex;
  align-items: center;
  gap: 5px;
}

.notification-link {
  cursor: pointer;
  color: $color-6;
  text-decoration: underline;

  &:hover {
    color: $color-7;
  }
}
</style>

<style lang="scss">
@import "@/assets/scss/variables.scss";
.notification-tabs .tabs li.is-active a {
  border-bottom-color: $color-7;
}

.notification-dropdown .dropdown-content {
  padding-bottom: 0;

  .tab-content {
    padding: 1rem 0;
  }
}

.notification-screen-button {
  border-radius: 0 0 4px 4px;
}
</style>
